export default {
  eip: {
    common:{
      search: '查詢',
      reset: '重置',
      save: '保存',
      cancel: '取消',
      up: '上移',
      down: '下移',
      remove: '刪除',
      clear: '清空',
      index: '序號',
      selected: '已選擇'
    },
    tree:{
      filterText: '輸入關鍵字進行過濾'
    },
    selectLang:{
      switchLang: '切換語言'
    }
  }
};